import { getCookie } from 'cookies-next/client';

import { extractSubdomainClient } from '@/lib/url';

/** Cookie written by the cookie banner (`src/components/Cookies.tsx`): `accepted` or `declined`. */
export const COOKIE_CONSENT_KEY = 'cookie-accept';

const APP_PREFIXES = ['/app', '/auth'];

/**
 * Every page outside the signed-in app and its login pages counts as a marketing page:
 * the landing pages, blog, docs, legal pages, confirmation pages and 404s.
 */
export function isMarketingPath(pathname: string): boolean {
  return !APP_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
}

export function hasAnalyticsConsent(): boolean {
  if (typeof document === 'undefined') {
    return false;
  }
  return getCookie(COOKIE_CONSENT_KEY) === 'accepted';
}

const currentHostname = () => (typeof window === 'undefined' ? '' : window.location.hostname);

/**
 * On marketing pages analytics runs only after the visitor accepted cookies.
 * A tenant subdomain has no marketing pages: the proxy rewrites its `/` to the employee login
 * and the browser keeps showing `/`, so that page counts as the app.
 */
export function isAnalyticsAllowed(pathname: string, hostname = currentHostname()): boolean {
  return (
    !isMarketingPath(pathname) || extractSubdomainClient(hostname) !== null || hasAnalyticsConsent()
  );
}
